import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const RoutingNumber = props => (
  <BaseInput
    name="routingNumber"
    label="Bank Routing Number"
    type="tel"
    autoComplete="off"
    transparent
    maxLength="9"
    validate={val =>
      string()
        .required('Bank Routing Number')
        .matches(/^\d{5,9}$/, {
          message: 'Routing number should be 5-9 numbers'
        })
        .max(9, 'Enter up to nine digit numeric characters')
        .min(3, 'Routing Number cannot be less than 3 characters')
        .test('valid-aba-routing', 'Invalid Routing Number', value => {
          if (value && value.length > 0) {
            let total = 0;
            for (let i = 0; i < value.length; i += 3) {
              total +=
                parseInt(value.charAt(i), 10) * 3 +
                parseInt(value.charAt(i + 1), 10) * 7 +
                parseInt(value.charAt(i + 2), 10);
            }
            return total !== 0 && total % 10 === 0;
          }
          return false;
        })
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

RoutingNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

RoutingNumber.defaultProps = {
  value: '',
  error: ''
};

export default RoutingNumber;
